<template>
    <div class="product">
        <nav-head :bg="false"></nav-head>
        <div class="ban-bg">
            <img src="~assets/images/product/txt-pro.png">
        </div>
        <logo-title :titleData="titleData[0]"></logo-title>
        <div class="source">
            <div class="sou-item">
                <div class="img-wrap">
                    <img src="~assets/images/home/logo2_06.png?v1">
                </div>
                <div class="btn">点击查看详情</div>
                <div class="mask hidden">
                    <h4>万方</h4>
                    <div class="txt">高校三大指定系统之一，隶禺中国科技信息研究所，数据库仅次于定稿系统，检测速度非常快</div>
                    <div>
                        价格适中，每年一个亿左右的销售额
                    </div>
                </div>
            </div>
            <div class="sou-item">
            <div class="img-wrap">
              <img src="~assets/images/home/logo_ywj.png">
            </div>
            <div class="btn" >点击查看详情</div>
            <div class="mask hidden">
              <h4>源文鉴</h4>
              <div class="txt">定稿系统新起之秀，隶属北方国家产权交易中心，为各教育部门及机构提供科学可靠的检测服务，且支持个人查重业务。</div>
              <div>
                预估每年五个亿左右销售额
              </div>
            </div>
          </div>
            <div class="sou-item">
                <div class="img-wrap">
                    <img src="~assets/images/home/logo1_03.png" style="height: 1.7rem;">
                </div>
                <div class="btn" >点击查看详情</div>
                <div class="mask hidden">
                    <h4>维普</h4>
                    <div class="txt">高校三大系统之一，深受学生们喜爱，大学生普遍在初稿时用维普</div>
                    <div>
                        每年2个亿左右销售额
                    </div>
                </div>
            </div>
            <div class="sou-item">
                <div class="img-wrap">
                    <img src="~assets/images/home/part03.png">
                </div>
                <div class="btn">点击查看详情</div>
                <div class="mask hidden">
                    <h4>Paperyy</h4>
                    <div class="txt">Paperyy以免费查重入场检重市场，第一次可免费查重，吸引查重人员使用</div>
                    <div>
                        和其他检测系统每年合计1个亿左右销售额
                    </div>
                </div>
            </div>
            <div class="sou-item">
                <div class="img-wrap">
                    <img src="~assets/images/home/part04.png">
                </div>
                <div class="btn">点击查看详情</div>
                <div class="mask hidden">
                    <h4>CheckPass</h4>
                    <div class="txt">目前市面上价格最低的检查系统价格低，适合论文初稿人员使用</div>
                    <div>
                        和其他检测系统每年合计1个亿左右销售额
                    </div>
                </div>
            </div>
            <div class="sou-item">
            <div class="img-wrap">
              <img src="~assets/images/home/part08.png">
            </div>
            <div class="btn">点击查看详情</div>
            <div class="mask hidden">
              <h4>PaperPass</h4>
              <div class="txt">论文查重市场后起之秀，相比万方、维普等系统价格低很多</div>
              <div>
                每年两个亿左右销售额
              </div>
            </div>
          </div>
            <div class="sou-item">
            <div class="img-wrap">
              <img src="~assets/images/home/part07.png">
            </div>
            <div class="btn">点击查看详情</div>
            <div class="mask hidden">
              <h4>Turnitin</h4>
              <div class="txt">适用于外语毕业论文，Essay，外刊投稿</div>
              <div>
                和其他检测系统每年合计1个亿左右销售额
              </div>
            </div>
          </div>
            <div class="sou-item">
                <div class="img-wrap">
                    <img src="~assets/images/home/part05.png">
                </div>
                <div class="btn">点击查看详情</div>
                <div class="mask hidden">
                    <h4>zaojiance</h4>
                    <div class="txt">论文查重市场后起之秀，拥有众多查重用户最重视市场，运营活动多</div>
                    <div>
                        和其他检测系统每年合计1个亿左右销售额
                    </div>
                </div>
            </div>
            <div class="sou-item">
                <div class="img-wrap">
                    <img src="~assets/images/home/dgxt.png">
                </div>
                <div class="btn">点击查看详情</div>
                <div class="mask hidden">
                    <h4>定稿系统</h4>
                    <div class="txt">更权威的论文检测系统，查重价格高， 检测速度非常快，不支持个人查重，学生定稿时才使用</div>
                    <div>
                        每年5个亿左右销售额
                    </div>
                </div>
            </div>
        </div>
        <logo-title :titleData="titleData[1]"></logo-title>
        <div class="support">
            <div class="item">
                <div class="item-title">
                    01
                    <h3>业务培训</h3>
                </div>
                <div class="item-txt">
                    强大的商家业务帮助平台, 1V1专项业务培训帮助,商家快速上手;随时辅助解决商家运营中出现的问题,提前控制解决商家忽略的风险,每位加盟商的强力后盾
                </div>
            </div>
            <div class="item">
                <div class="item-title">
                    02
                    <h3>技术服务</h3>
                </div>
                <div class="item-txt">
                    强大的技术研发队伍,只要你有需求,我们同意，我们就能把你的想法快速落地
                </div>
            </div>
            <div class="item">
                <div class="item-title">
                    03
                    <h3>品牌推广</h3>
                </div>
                <div class="item-txt">
                    手握各种校园、渠道等教育资源,又不知道怎样推广才能快速变现?我们帮你制定推广方案,实现互利共赢
                </div>
            </div>
        </div>
        <div class="profit">
            <logo-title :titleData="titleData[2]"></logo-title>
            <div class="pro-items">
                <div class="item">在线交易的盈利模式</div>
                <div class="item">基于广告的盈利模式</div>
                <div class="item">校企合作的盈利模式</div>
                <div class="item">渠道销售的盈利模式</div>
            </div>
        </div>
        <logo-title :titleData="titleData[3]"></logo-title>
        <div class="equity">
            <div class="eq-bg">
                <div class="txt-wrap">
                    <p class="tit">免费</p>
                    <p class="tit">合伙人</p>
                    <div class="line"></div>
                    <p class="txt">0成本试用</p>
                    <p class="txt">收益较低</p>
                </div>
            </div>
            <div class="eq-bg">
                <div class="txt-wrap">
                    <p class="tit">付费</p>
                    <p class="tit">合伙人</p>
                    <div class="line"></div>
                    <p class="txt">低成本进货</p>
                    <p class="txt">定制专属VIP独立网站</p>
                    <p class="txt">提供多渠道变现项目</p>
                </div>
            </div>
        </div>
        <input-wrap></input-wrap>
        <back-top></back-top>
        <footer-version></footer-version>
    </div>
</template>

<script>
    import {NavHead,LogoTitle,InputWrap,FooterVersion,BackTop} from "../components";
    import $ from 'jquery'
    import {linkRefresh} from "../common/mixin";

    export default {
        name: "Product",
        components: {
            NavHead,
            LogoTitle,
            InputWrap,
            BackTop,
            FooterVersion
        },
        data() {
            return {
                titleData: [
                    {
                        title:'产品库与资源库',
                        txt:'加入PAPER联盟可对9大系统进行销售，其中万方享有独家代理权',
                        space:0
                    },
                    {
                        title:'三大支持',
                        txt:'THREE MAJOR SUPPORT',
                        space:5
                    },
                    {
                        title:'长期的盈利模式',
                        txt:'LONG TERM PROFIT MODEL',
                        space:5
                    },
                    {
                        title:'合伙人权益',
                        txt:"PARTER'S RIGHT ",
                        space:5
                    },
                ],
            }
        },
        mixins:[linkRefresh],
        mounted() {
            $('.sou-item').on('click',function () {
                let _display = $(this).find('.mask').css('display')
                if(_display == 'none'){
                    $(this).find('.btn').addClass('hidden')
                    $(this).find('.mask').removeClass('hidden')
                }
                else  {
                    $(this).find('.btn').removeClass('hidden')
                    $(this).find('.mask').addClass('hidden')
                }
            })
        },
        methods: {
        }
    }
</script>

<style scoped lang="less">
    .ban-bg {
        background-image: url("~assets/images/product/bg-pro.jpg");
        img {
            height: 74px;
        }
    }
    .hidden {
        display: none;
    }
    .source {
        padding: 30px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .sou-item {
            width: 48%;
            height: 290px;
            text-align: center;
            border: 1px solid #d8d8d8;
            margin-bottom: 30px;
            border-radius: 5px;
            position: relative;
            .img-wrap {
                height: 195px;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                    height: 65px;
                }
            }
            .btn{
                background: linear-gradient(90deg,#1873af,#62b1dc);
                height: 95px;
                line-height: 95px;
                font-size: 24px;
                color: #fff;
            }
            .mask {
                height: 100%;
                width: 100%;
                background: rgba(0,0,0,0.7);
                position: absolute;
                top: 0;
                left: 0;
                color: #fff;
                padding: 30px 20px;
                box-sizing: border-box;
                text-align: left;
                font-size: 20px;
                line-height: 26px;
                border-radius: 5px;
                h4 {
                    font-size: 24px;
                    border-bottom: 1px solid #7d7d7d;
                    padding-bottom: 15px;
                }
                .txt {
                    border-bottom: 1px solid #7d7d7d;
                    padding: 20px 0;
                    margin-bottom: 15px;

                }
            }
        }
    }
    .support {
        padding: 0 30px 30px;
        .item {
            display: flex;
            height: 168px;
            box-shadow: 0 0 5px #e9e9e9;
            margin-bottom: 40px;
            .item-title {
                width: 180px;
                background: #126eac;
                text-align: center;
                line-height: 180px;
                font-size: 100px;
                font-weight: bold;
                color: #4081b5;
                position: relative;
                h3 {
                    color: #ffffff;
                    font-size: 30px;
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%,-50%);
                }
            }
            .item-txt {
                font-size: 20px;
                color: #767676;
                padding: 25px;
                flex: 1;
                line-height: 30px;
                display: flex;
                align-items: center;
            }
            &:nth-child(2n){
                flex-flow: row-reverse;
                .item-title {
                    color: #f47d50;
                    background: #f3692e;

                }
            }

        }
    }
    .profit {
        background: #fafafa;
        .pro-items {
            padding: 30px;
            display: flex;
            justify-content: space-around;
            flex-wrap: wrap;

            div {
                width: 45%;
                height: 362px;
                background-repeat: no-repeat;
                background-size: 100% 100%;
                font-size: 24px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #fff;
                border-radius: 5px;
                margin-bottom: 20px;
                &:first-child {
                    background-image: url('~assets/images/product/profit1.png');
                }
                &:nth-child(2){
                    background-image: url('~assets/images/product/profit2.png');
                }
                &:nth-child(3){
                    background-image: url('~assets/images/product/profit3.png');
                }
                &:nth-child(4){
                    background-image: url('~assets/images/product/profit4.png');
                }
            }
        }
    }
    .equity {
        margin: 0 30px;
        position: relative;
        height: 1070px;
        .eq-bg {
            height: 600px;
            width: 100%;
            background-size: 100% 100%;
            background-repeat: no-repeat;
            display: flex;
            align-items: center;
            .txt-wrap {
                margin-right: 110px;
                margin-bottom: 20px;
                width: 210px ;
                .line {
                    height: 2px;
                    background: #98B8D4;
                    width: 100%;
                    margin: 20px 0;
                }
                .txt {
                    font-size: 24px;
                    color: #333;
                }
            }
            .tit {
                font-size: 60px;
                color: #2D83BB;
                font-weight: bold;
                &:last-child {

                }
            }
            &:first-child {
                background-image: url("~assets/images/product/equity1.png");
                position: absolute;
                left: 0;
                top: -30px;
                justify-content: flex-end;
            }
            &:last-child {
                height: 625px;
                background-image: url("~assets/images/product/equity2.png");
                position: absolute;
                bottom: -50px;
                text-align: right;
                .txt-wrap {
                    margin: 0 0 20px 40px;
                    width: 230px;
                    .tit{
                        color: #fff;
                    }
                    .txt {
                        color: #DADADA;
                    }
                    .line {
                        background: #DADADA;
                        height: 1px;
                        width: 80%;
                        margin-left: 20%;
                    }
                }
            }

        }
    }
</style>